import React from "react";
import { Button } from "@mui/material";

export default function BlueLightOutlinedButton({
  startIcon,
  buttonTitle,
  onClick,
  endIcon,
  minWidth
}) {
  return (
    <Button
      variant="outlined"
      startIcon={startIcon ? startIcon : ""}
      onClick={onClick}
      endIcon={endIcon}
      sx={{
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 700,
        height: "30px",
        textTransform: "none",
        border:"1px solid #E7CEF6",
        color: "#572575",
        px: 3,
        fontFamily:"Inter",
        boxShadow:" 0px 3px 4px 0px rgba(200, 141, 235, 0.27)",
        background:"#FFFFFF",
            minWidth: { minWidth },
        "&:hover" :{
         border:"1px solid #E7CEF6",

             background:"#FFFFFF",
         
        }
       
      }}
    >
      {buttonTitle}
    </Button>
  );
}
